import {h, Fragment} from "preact"
import Product from './Product'
import { useAppState, useProductFilters } from '@nosto/preact'
import { filterColorMapping } from '../helpers'
import { useEffect } from 'preact/hooks'

export default function Products() {
    const {
        response: { products, query },
        loading,
        pageType
    } = useAppState()
    const { filters, removeAll } = useProductFilters()

    useEffect(() => {
        // Handle color filtering when products change
        console.log("FILTERS", filters);
        const activeColorFilters = filters
            .filter((filter) => filter.field === 'extra.Color' || filter.field === 'color')
            .map((filter) => filter.value)

        console.log("ACTIVE COLORS", activeColorFilters[0]?.trim());

        if (activeColorFilters.length === 1) {
            // Apply filterColorMapping for the single active color filter
            filterColorMapping(activeColorFilters[0]?.trim())
        }

        if(activeColorFilters[0]?.trim() == undefined){
            document.querySelectorAll(".ns-product").forEach(product => {
                product.querySelector('.product-option__option-values label')?.click();
            })
        }

        // List of available colors
        const availableColors = [
            'Black',
            'Grey',
            'Yellow',
            'Green',
            'Red',
            'Blue',
            'White',
            'Orange',
            'Pink',
            'Purple',
            'Brown',
            'Khaki',
            'Multi',
        ]

        // Check if query contains any color names
        if (query) {
            const lowerQuery = query.toLowerCase()

            // Check if query contains any of our available colors
            for (const color of availableColors) {
                if (lowerQuery.includes(color.toLowerCase())) {
                    filterColorMapping(color)
                    break // Process only the first color match
                }
            }
        }
    }, [products, filters, query]) // Run effect when products, filters, or query changes

    return (
        <div class="ns-d-flex ns-flex-wrap product-listing" style={loading ? 'opacity: 0.3;' : ''}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} pageType={pageType} />
            })}
        </div>
    )
}
